import { Insta } from "../../src/components/insta/InstaClass";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { getInstaImage } from "../helpers/helpers";
import { images } from "./images";
import { V7AnnPreAuditionAfter } from "./V7";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

export const V7AnnPreAudition = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_0);

    ann.talk(`Good morning!`);
    mc.talk(`Come on in.`);
    ann.talk(`Thank you!`);
    mc.think(`...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    mc.talk(`I just woke up.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p);
    ann.talk(`I'm making it an habit of waking you up! Hehe.`);
    ann.talk(`Today is the big day! I barely got any sleep!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_p);
    ann.talk(`I'm kinda nervous.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    mc.talk(`You should be... You are going to audition for the first time, in front of people without experience...`);
    ann.talk(`Yeah... Thanks for the reminder, hehe.`);
    ann.talk(`By the way, have you seen the pictures I've posted on Insta?`);

    const MCImagesSeen = Insta.instaProfiles?.[ann.key]?.images.filter(image => ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).includes(image.key) && image.mcSeen) || [];


    if (MCImagesSeen.length > 0) {
        mc.talk(`I have.`);
        ann.talk(`Did you like them?`);
        mc.talk(`Yes, they are great.`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p);
        if (getInstaImage(Insta.instaProfiles?.[ann.key], `${ann.key}16`) || getInstaImage(Insta.instaProfiles?.[ann.key], `${ann.key}16`)) {
            ann.talk(`I've decided to upload the pictures with those guys we met...`);
            ann.talk(`I've listened to your advice, it will make people think I'm very popular!`);
            mc.talk(`Nice.`);
            if (Question.globalAnswers.todAnnAsksWhyKissJoe === "IlikeSeeingYouWithOthers") {

                ImageClass.setImage(images.v7.AnnChrisPreAudition_39);
                ann.talk(`And I know you loved seeing me with them... So... Yeah, hehe.`);
            }
        }

    } else {

        mc.talk(`No, I haven't seen them yet.`);
        ann.talk(`Really? You invested so much time in taking them.`);
        mc.talk(`I guess I just missed it. I will look at the first chance I get.`);
    }


    if (mc.properties.v7AnnChrisMovieStatus === "went") {
        return jump(V7AnnPreAuditionMovieTalk, "V7AnnPreAuditionMovieTalk");
    } else if (mc.properties.v7AnnChrisMovieStatus === "refused") {

        return jump(V7AnnPreAuditionMovieTalkMiss, "V7AnnPreAuditionMovieTalkMiss");
    }

    return jump(V7AnnPreAudition2, "V7AnnPreAudition2");
};

export const V7AnnPreAuditionMovieTalk = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    ann.talk(`We didn't have a chance to talk yesterday.`);
    ann.talk(`I hope you had fun.`);
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {
        if (Question.globalAnswers.v7AnnChrisMoviesTouchedAnn) {
            ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p);
            mc.talk(`How couldn't I?`);
            ann.talk(`Right! Hehe.`);
            ann.talk(`I haven't had the chance to talk to you about that... But you got me so aroused yesterday...`);
            ann.talk(`The way you touched me...`);
            mc.talk(`I felt it.`);
            if (Question.globalAnswers.v7PhotoShootOutsideToldAnnYouWantToFuck) {
                ann.talk(`We had a busy day yesterday... Not only did we have sex outdoors, you also touched me in a theater full of people!`);

            }
            ImageClass.setImage(images.v7.AnnChrisPreAudition_39);
            ann.talk(`I felt like a naughty girl!`);
            mc.talk(`Did you like it?`);
            ann.talk(`A lot.`);
            mc.talk(`Did you manage to watch the movie at all?`);
            ann.talk(`Parts...`);
            ann.talk(`Hehe, but it was worth it!`);
        } else {
            mc.talk(`It was nice.`);
            ImageClass.setImage(images.v7.AnnChrisPreAudition_40);
            ann.talk(`Yeah...`);
            mc.talk(`Is there something wrong?`);
            ImageClass.setImage(images.v7.AnnChrisPreAudition_41);
            ann.talk(`Nothing really.`);
            if (mc.properties.alpha >= 8) {

                mc.talk(`Speak.`);
            } else {
                mc.talk(`Come on, what is it?`);

            }
            ann.talk(`Well... I was expecting you'd try to make a move or something on me yesterday.`);
            mc.talk(`I would have if you weren't my girlfriend and it was our first time or something.`);
            mc.talk(`Besides, I knew how much you wanted to watch the movie, I didn't want to disturb you.`);
            ImageClass.setImage(images.v7.AnnChrisPreAudition_2);
            ann.talk(`I guess it makes sense.`);
            if (mc.properties.alpha >= 8) {

                mc.talk(`So you can relax now.`);
            } else {

                mc.talk(`So, we are good now?`);
            }
            ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_1, partialsToDisplay: [images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p] });
            ann.talk(`Yeah, thanks!`);
        }


    } else {
        ImageClass.setImage(images.v7.AnnChrisPreAudition_39);
        ann.talk(`Because I did! Hehe.`);
        if (Question.globalAnswers.todAnnAsksWhyKissJoe === "IlikeSeeingYouWithOthers") {

            ann.talk(`I know you like watching me so I allowed myself to get wild...`);
            ann.talk(`I won't lie... It was really exciting...`);
            ann.talk(`And when I saw you looking at me, you looked so pleased... It really turned me on.`);
        } else if (Question.globalAnswers.v7AnnChrisMoviesAgreeToChrisTouchingHer) {
            ann.talk(`I know you did as well because when I looked at you, you approved what was going on.`);
            ann.talk(`You know.... It really turned me on when I saw you looking at me with Chris.`);
            mc.talk(`I know, I saw.`);
        } else if (Question.globalAnswers.v7AnnChrisMoviesAgreeToChrisTouchingHer === false) {
            ImageClass.setImage(images.v7.AnnChrisPreAudition_40);
            ann.talk(`I saw that you weren't pleased with what was going on.`);
            mc.talk(`But you still kept going.`);
            ImageClass.setImage(images.v7.AnnChrisPreAudition_41);
            ann.talk(`I know...`);
            ann.talk(`It wasn't my fault. He kept touching me and I got so aroused, I couldn't stop.`);
            ann.talk(`Besides, you had me sit on his lap instead of yours...`);
            mc.think(`She isn't wrong... I'll just change the subject.`);
        }

    }



    return jump(V7AnnPreAudition2, "V7AnnPreAudition2");
};


export const V7AnnPreAuditionMovieTalkMiss = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_1, partialsToDisplay: [images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_p] });
    await ann.setQuestion(new Question({ text: `Great!`, options: { think: false }, key: `v7PreAuditionAskedHowMoviesWithChrisWere` })
        .option({ title: `Ask how it was with Chris`, key: true })
        .option({ title: `Don't mention the movie`, key: false }));


    if (Question.globalAnswers.v7PreAuditionAskedHowMoviesWithChrisWere) {

        return jump(V7AnnPreAuditionMovieTalkMiss_Chris, "V7AnnPreAuditionMovieTalkMiss_Chris");
    } else {

        return jump(V7AnnPreAudition2, "V7AnnPreAudition2");
    }

};

export const V7AnnPreAuditionMovieTalkMiss_Chris = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);

    mc.talk(`Say.`);
    ann.talk(`Yes?`);
    mc.talk(`How was it with Chris yesterday?`);
    if (mc.properties.v7AnnChrisMovieStatus === "refused") {
        ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_p);
        ann.talk(`Oh... It was amazing! I really enjoyed the movie!`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_2);
        ann.talk(`It's too bad you didn't come! I think you'd have enjoyed it.`);
        mc.talk(`Nah, it's not my thing.`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
        ann.talk(`I know.`);
        if (mc.properties.v7WentWithJennyDate) {
            mc.think(`Chris was curious to know if I'd spoken with Ann about the movie...`);
            mc.think(`Now I have, but she didn't say anything special.`);
            mc.think(`I wonder what he meant.`);
        }

    } else if (mc.properties.v7AnnChrisMovieStatus === "wasntInvited") {
        ImageClass.setImage(images.v7.AnnChrisPreAudition_40);
        ann.talk(`Ahh...`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_39);
        ann.talk(`Hehe, it was fine.`);
        mc.talk(`It seems more than fine.`);

        ImageClass.setImage(images.v7.AnnChrisPreAudition_41);
        ann.talk(`Don't take that the wrong way.`);

        ann.talk(`I'm sorry you weren't able to join.`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_40);
        ann.talk(`I really nagged Chris to get us another ticket but he said his guy refused...`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_41);
        mc.talk(`At least you had fun.`);

        ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_1, partialsToDisplay: [images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p] });

        ann.talk(`I did! Thank you.`);
    }

    if (mc.properties.chrisStatus === "enemy" && mc.properties.v7WentWithJennyDate) {
        ImageClass.setImage(images.v7.AnnChrisPreAudition_2);
        ann.talk(`And for some reason he texted me later at night and asked me to come to the bar...`);
        ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
        ann.talk(`I told him I was going to sleep. Weird.`);
        mc.think(`I bet he wanted to snitch on me after seeing me at the bar with Jenny.`);
        mc.think(`Not cool, even though we are not friends, there is still a bro code.`);
    }

    if (mc.properties.v7AnnChrisMovieStatus == "wasntInvited" || mc.properties.v7AnnChrisMovieStatus == "refused") {
        mc.think(`She didn't elaborate too much about the movie she wanted to see so much...`);
        mc.think(`I wonder what really happened there.`);
        mc.think(`I guess I'll find out later.`);
    }


    return jump(V7AnnPreAudition2, "V7AnnPreAudition2");
};

export const V7AnnPreAudition2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    mc.talk(`I see you are wearing the same clothes.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p);
    ann.talk(`Oh yeah! I like them so much it's hard for me to wear something else at this point.`);
    ann.talk(`Besides, I get so much compliments, I decided to use them for the audition as well.`);
    mc.talk(`Makes sense, it does attract attention.`);
    ann.talk(`Yeah! Hehe.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    mc.talk(`Ok, so how are we gonna do this? Do you have a script that you need me to read?`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_p);
    ann.talk(`Not really...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    ann.talk(`It's more about improvising...`);
    ann.talk(`The director wanna see us out of our comfort zone.`);
    mc.talk(`Didn't you say he is looking for an inexperience actresses?\nWhat comfort zone do they have?`);
    ann.talk(`Yeah, I guess it's stupid.`);
    mc.talk(`Is he gonna do the same script like the one we saw?`);
    mc.talk(`A girlfriend begging for her boyfriend not to leave her?`);
    ann.talk(`The rumors say he never changes scenarios in the same city.`);
    mc.talk(`Perfect! Let's just practice that one.`);
    ann.talk(`We can do that!`);
    if (Question.globalAnswers.v1EnableNTR && mc.properties.v7AnnChrisMovieStatus) {

        return jump(V7AnnPreAuditionNtr, "V7AnnPreAuditionNtr");
    } else {

    }

    return jump(V7AnnPreAudition3, "V7AnnPreAudition3");
};

export const V7AnnPreAuditionNtr = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_1, partialsToDisplay: [images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p] });
    ann.talk(`There is something I gotta ask you before we start.`);
    mc.talk(`Sure, what is it?`);
    ann.talk(`I've talked with Chris about the audition as well and he suggested he could help me.`);
    ann.talk(`I said that I'll check it with you first, since you are the first one I've talk to about it.`);
    return jump(V7AnnPreAuditionNtr_Question, "V7AnnPreAuditionNtr_Question");
};

export const V7AnnPreAuditionNtr_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_1);
    await ann.setQuestion(new Question({ text: `I'd totally understand if you said no.`, options: { think: false }, key: `v7PreAuditionLetAnnInviteChris` })
        .option({ title: `Invite Chris`, key: true })
        .option({ title: `Don't invite him`, key: false }));


    if (Question.globalAnswers.v7PreAuditionLetAnnInviteChris) {

        return jump(V7AnnPreAuditionNtr_Question_InviteChris, "V7AnnPreAuditionNtr_Question_InviteChris");
    } else {

        return jump(V7AnnPreAudition_Question_Alone, "V7AnnPreAudition_Question_Alone");
    }

};


export const V7AnnPreAuditionNtr_Question_InviteChris = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_1, partialsToDisplay: [images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_2_p] });

    await mc.set((properties) => {
        properties.v7PreAuditionProgress.push("Invited-Chris");
    });
    mc.talk(`Go ahead, invite him.`);
    ann.talk(`Really?`);
    if (mc.properties.v7AnnChrisMovieStatus === "wasntInvited") {
        ann.talk(`I honestly thought you'd said no after he couldn't get a ticket for you yesterday.`);
        ann.talk(`But I guess you are just a better man! Hehe.`);
    }
    ann.talk(`I'm calling him right now!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_3);
    ann.talk(`Hey Chris?`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_4);
    ann.talk(`Yes! Hehe.`);
    ann.talk(`I'm fine, how are you?`);
    ann.talk(`No, no... Hehehe.`);
    ann.talk(`Really? Now?`);
    ann.talk(`Oh! Great.`);
    ann.talk(`Stop it! Hehe.`);
    ann.talk(`No no, it's something else.`);
    ann.talk(`I'm about to practice the audition with ${mc.name} and I was wondering if you'd like to join us.`);
    ann.talk(`Yes of course!`);
    ann.talk(`No! He even suggested it.`);
    ann.talk(`Ok! Hehe.`);
    ann.talk(`We are waiting. Bye!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_5);
    ann.talk(`He will be right over!`);
    ImageClass.setImage(images.v2_5.BlackScreen);
    empty.think(`Some time later...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_6);
    chris.talk(`Hey guys.`);
    mc.talk(`Hey Chris.`);
    if (mc.properties.chrisStatus === "enemy") {

        mc.think(`I'm surprised he just showed up with the rivalry going on between us.`);
        mc.think(`Maybe he just doesn't say no to Ann?`);
    }
    ImageClass.setImage(images.v7.AnnChrisPreAudition_7);
    ann.talk(`Thanks for coming!`);
    chris.talk(`You're welcome, but I don't have much time, I made plans.`);
    ann.talk(`It won't be long.`);
    chris.talk(`Ok, good.`);
    return jump(V7AnnPreAuditionNtr_InviteChris2, "V7AnnPreAuditionNtr_InviteChris2");
};

export const V7AnnPreAuditionNtr_InviteChris2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_7);
    chris.talk(`So what do you need me to do?`);
    ann.talk(`Ok, so we're both gonna be the actors and ${mc.name} will be the director that tells us what to do.`);
    chris.talk(`Ok, but don't count on my acting skills.`);
    ann.talk(`I bet I'm worst... Hehe.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_8);
    ann.talk(`We are ready.\nHow do you want us to get started?`);
    mc.talk(`Since you said it's about a girl trying to prevent a break up, just start with that.`);
    mc.talk(`Chris, you decided to finish the relationship and Ann is trying to convince you to stay.`);
    chris.talk(`Sounds easy enough.`);
    mc.talk(`Ok, you can start.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_9, { transition: true, duration: 0.6 });
    mc.talk(`And...`);
    mc.talk(`Action!`);
    ann.talk(`Mmm... Ok.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_10);
    ann.talk(`Hey... I really don't want you to leave... Please.`);
    ann.talk(`I... I know I've been a bad girlfriend but I love you so much! Please don't leave.`);
    mc.talk(`Ha...`, { method: "Quiet Laughter" });
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    ann.talk(`Why are you laughing?`);
    mc.talk(`Sorry. It's just a bit funny.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11.partials.AnnChrisPreAudition_11_p);
    ann.talk(`You need to encourage me!`);
    mc.talk(`I know, but don't forgot you'd have to deal with people laughing at you as well.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    ann.talk(`Yeah, you are right.`);
    mc.talk(`Ok, continue.`);

    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    ann.talk(`Ahem...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_10);
    ann.talk(`Please, please, please don't go.`);
    ann.talk(`I'll do anything, just tell me why are you leaving.`);
    chris.talk(`I don't feel it anymore.`);
    ann.talk(`No! Don't say that.`, { method: "Sobbing" });
    chris.talk(`I said no, that's my final answer.`);
    ann.talk(`Ah...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    ann.talk(`What do I do now? He said no...`);
    mc.talk(`Really? That's how you convince someone you love to stay with you?`);
    ann.talk(`I don't know... I've never been in this situation.`);
    mc.talk(`That's the problem, you need to imagine like this is real, and you are about to lose him for good.`);
    mc.talk(`You can't just stop and make everything go back to normal.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11.partials.AnnChrisPreAudition_11_2_p);
    if (mc.properties.chrisStatus === "friend") {
        chris.talk(`You convinced me.`);
        chris.talk(`Bro, you should consider being a real director.`);
        mc.talk(`Haha.`);
    }

    ann.talk(`Ok. I think I understand.`);
    return jump(V7AnnPreAuditionNtr_InviteChris2_Question, "V7AnnPreAuditionNtr_InviteChris2_Question");
};

export const V7AnnPreAuditionNtr_InviteChris2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    await ann.setQuestion(new Question({ text: `Do you have more tips before I'll try again?`, options: { think: false }, key: `v7PreAuditionToldAnnToBegToChris` })
        .option({ title: `Beg (Get on your knees)`, key: true })
        .option({ title: `Keep doing what you're doing`, key: false }));


    if (Question.globalAnswers.v7PreAuditionToldAnnToBegToChris) {
        return jump(V7AnnPreAuditionNtr_InviteChris2_Question_Beg, "V7AnnPreAuditionNtr_InviteChris2_Question_Beg");

    } else {
        return jump(V7AnnPreAuditionNtr_InviteChris2_Question_KeepDoing, "V7AnnPreAuditionNtr_InviteChris2_Question_KeepDoing");

    }
};

export const V7AnnPreAuditionNtr_InviteChris2_Question_Beg = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    await mc.set((properties) => {
        properties.v7PreAuditionProgress.push("Begged-Chris");
    });
    mc.talk(`Yes, I do.`);
    mc.talk(`Do, the same as you just did, but try to be more dramatic.`);
    ann.talk(`How?`);
    mc.talk(`Do something that someone who is desperate for something will do. Beg.`);

    ann.talk(`Didn't I just do that?`);
    mc.talk(`I mean physically.`);
    mc.talk(`Get down on your knees and beg.`);
    ann.talk(`Oh...`);
    ann.talk(`I would never do that in real life.`);
    mc.talk(`It's for a movie not real life.`);
    ann.talk(`Yeah...`);
    mc.talk(`Action!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_9);
    ann.talk(`Ahm ahm...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_10);
    ann.talk(`Please! Please don't leave me.`);
    ann.talk(`I'll do anything you want from now on!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_12);
    ann.talk(`Please! I'm on my knees begging you to stay.`);
    ann.talk(`What more can I do?`);
    chris.talk(`Wait, stop.`);
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_9_p] });
    chris.talk(`What happened?`);
    chris.talk(`You seem nervous.`);
    ann.talk(`I am...`);
    ann.talk(`I feel like I'm being judged doing something I'm not really comfortable doing.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_9);
    chris.talk(`Do you know the number one advice that people give while performing in front of a crowd?`);
    ann.talk(`What's that?`);
    chris.talk(`They say, you should imagine all of them naked so it makes you feel more comfortable and in control.`);
    return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Question, "V7AnnPreAuditionNtr_InviteChris2_Beg_Question");


};

export const V7AnnPreAuditionNtr_InviteChris2_Beg_Question = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_9_p] });
    await mc.setQuestion(new Question({ text: `I think I know where he is going with this.`, options: { think: false }, key: `v7PreAuditionLetAnnSuckChrisCock` })
        .option({ title: `Agree with him`, key: true })
        .option({ title: `Don't agree`, key: false }));


    if (Question.globalAnswers.v7PreAuditionLetAnnSuckChrisCock) {
        return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Question_Agree, "V7AnnPreAuditionNtr_InviteChris2_Beg_Question_Agree");

    } else {
        return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Question_DontAgree, "V7AnnPreAuditionNtr_InviteChris2_Beg_Question_DontAgree");

    }

};

export const V7AnnPreAuditionNtr_InviteChris2_Beg_Question_Agree = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_9_p] });
    await mc.set((properties) => {
        properties.v7PreAuditionProgress.push("Chris-Blowjob");
    });
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {

        mc.think(`Yesterday I kinda cock blocked him...`);
        mc.think(`It's the perfect opportunity to return a favor...`);
    }
    mc.talk(`I agree.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    ann.talk(`Do you?`);
    mc.talk(`Yes. It will make you feel more comfortable.`);
    ann.talk(`If you think that's necessary I won't argue.`);
    chris.talk(`Gimme a second.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_14, { transition: true, duration: 0.6 });
    ann.talk(`Woah. You weren't joking.`);
    chris.talk(`I never joke about getting naked.`);
    chris.talk(`Doesn't it make you feel more comfortable?`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_14.partials.AnnChrisPreAudition_14_p);
    ann.talk(`Not really. Hehe.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_15);
    ann.talk(`So what do we do now? Do we just continue?`);
    mc.talk(`Yes.`);
    mc.talk(`Action!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_16);
    ann.talk(`Please! Please don't leave me.`);
    ann.talk(`I'll do anything you want from now on!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_17);
    ann.talk(`Please! I'm on my knees begging you to stay.`);
    chris.talk(`I'm not convinced.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_18);
    mc.think(`She is looking at me, waiting for me to say something.`);
    mc.think(`I'm not gonna intervene this time.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_17);
    ann.talk(`Ahem.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_19);
    ann.talk(`Honey! I'm on my knees begging you to stay!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_20, { duration: 1 });
    ann.talk(`Oh...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_21);
    ann.talk(`I don't think that's part of the script.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_22);
    chris.talk(`Don't break character.`);
    mc.think(`I don't think he's gonna back off now.`);
    ImageClass.setImage(images.v7.Anim_AnnChrisPreAudition.poster);
    mc.think(`And why should he?`);
    ImageClass.setAnimation(images.v7.Anim_AnnChrisPreAudition);
    mc.think(`He owes me one.`);
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn == false) {

        mc.talk(`I guess that's what he was expecting to happen yesterday.`);
    }
    ImageClass.setAnimation(images.v7.Anim_AnnChrisPreAuditionFar);
    chris.talk(`I'm five seconds away from forgiving her.`);

    ImageClass.setAnimation(images.v7.Anim_AnnChrisPreAudition);
    chris.talk(`Keep going!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_28, { duration: 0.6, wait: 0.8 });
    ImageClass.setImage(images.v7.AnnChrisPreAudition_29, { duration: 0.6, wait: 0.8 });
    ImageClass.setImage(images.v7.AnnChrisPreAudition_30, { duration: 0.6 });
    chris.talk(`AHH!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_31);
    chris.talk(`I forgive you.`);
    ann.talk(`Hehe.`);

    ImageClass.setImage(images.v7.AnnChrisPreAudition_32);
    ann.talk(`I did it!`);

    await endReplay(replayScenesList.v7AnnPreAuditionChris);

    ImageClass.setImage(images.v7.AnnChrisPreAudition_33);

    chris.talk(`Thanks, it was fun...`);
    chris.talk(`Call me next time you wanna practice.`);
    chris.talk(`I need to get going now.\nBye.`);


    return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question, "V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question");
};

export const V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_43);
    await ann.setQuestion(new Question({ text: `Wow... I think we got carried away.`, options: { think: false }, key: `v7PreAuditionAfterChrisCumshot` })
        .option({ title: `Make her suck your cock (Dirty)`, key: `dirtyBlowjob` })
        .option({ title: `Make her suck your cock (Clean up first)`, key: `cleanBlowjob` })
        .option({ title: `End practice`, key: `end` }));


    if (Question.globalAnswers.v7PreAuditionAfterChrisCumshot === "dirtyBlowjob") {
        return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Dirty, "V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Dirty");

    } else if (Question.globalAnswers.v7PreAuditionAfterChrisCumshot === "cleanBlowjob") {
        return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Clean, "V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Clean");

    }

    await endReplay(replayScenesList.v7AnnPreAuditionChris);
    return jump(V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Finish, "V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Finish");


};


export const V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Dirty = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_43);
    ann.talk(`Gimme a second to clean up.`);
    mc.talk(`Don't. It turns me on seeing you like this.`);
    return jump(V7AnnPreAuditionNtr_InviteChris3, "V7AnnPreAuditionNtr_InviteChris3");
};


export const V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Clean = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_43);
    ann.talk(`Gimme a second to clean up.`);
    mc.talk(`Ok, I'm waiting.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_3, { transition: true });
    ann.talk(`Done.`);
    ann.talk(`We should get going, we're gonna be late.`);
    mc.talk(`What about me?`);
    ann.talk(`What do you mean?`);
    mc.talk(`Chris got a blowjob. Now it's my turn.`);
    ann.talk(`But the audition...`);
    mc.talk(`It can wait.`);
    mc.talk(`Get down on your knees.`);
    return jump(V7AnnPreAuditionNtr_InviteChris3, "V7AnnPreAuditionNtr_InviteChris3");
};

export const V7AnnPreAuditionNtr_InviteChris3 = async (): Promise<any> => {

    ImageClass.setImage(images.v7.AnnMCPreAudition_11);
    mc.talk(`Suck it.`);
    if (Question.globalAnswers.v7PreAuditionAfterChrisCumshot === "dirtyBlowjob") {
        ImageClass.setAnimation(images.v7.Anim_AnnMCPreAuditionCum);

    } else {
        ImageClass.setAnimation(images.v7.Anim_AnnMCPreAudition);

    }


    mc.talk(`Yeah... Keep going.`);
    if (Question.globalAnswers.v7PreAuditionAfterChrisCumshot === "dirtyBlowjob") {
        mc.think(`Watching her sucking my cock while her face is covered with cum is such a turn on.`);

    }
    mc.talk(`Fuck, I'm gonna cum!`);


    ImageClass.setImage(images.v7.AnnMCPreAudition_16, { wait: 1 });


    ImageClass.setImage(images.v7.AnnMCPreAudition_17, { wait: 1 });


    ImageClass.setImage(images.v7.AnnMCPreAudition_18);
    mc.talk(`AHHH!`);
    ann.talk(`I guess I did a good job. Hehe.`);
    if (Question.globalAnswers.v7PreAuditionAfterChrisCumshot === "dirtyBlowjob") {
        ann.talk(`Again!`);

    }
    ImageClass.setImage(images.v7.AnnMCPreAudition_19);
    ann.talk(`I didn't expect you'd do that.`);
    mc.talk(`Damn, that was hot.`);
    mc.talk(`Go clean up and we can go.`);
    await endReplay(replayScenesList.v7AnnPreAuditionChris);
    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};

export const V7AnnPreAuditionNtr_InviteChris2_Beg_Agree_Question_Finish = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_43);
    ann.talk(`I'm gonna clean up and we should go, I don't wanna be late.`);
    mc.talk(`I'm waiting.`);
    await endReplay();

    ImageClass.setImage(images.v7.AnnChrisPreAudition_39, { transition: true });
    ann.talk(`I think we should leave now.`);
    mc.talk(`Let's go.`);

    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};

export const V7AnnPreAuditionNtr_InviteChris2_Beg_Question_DontAgree = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_9_p] });
    mc.think(`I think he had enough fun for one day.`);
    mc.talk(`Nah, I don't agree.`);
    mc.talk(`Just continue as it is.`);
    if (mc.properties.chrisStatus === "friend") {
        ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_11_3_p] });
        chris.talk(`Really bro?`);
        mc.talk(`Just continue like this.`);
    } else if (mc.properties.chrisStatus === "enemy") {
        ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_11_3_p] });
        chris.talk(`Obviously you wouldn't agree.`);
        mc.talk(`How could I? That's a stupid idea.`);
    }

    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_11, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_11_3_p] });
    chris.talk(`So much for fun.`);
    chris.talk(`I just realized how the time flew by.`);
    chris.talk(`I gotta get going. Cya.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_41, { transition: true, duration: 0.6 });
    ann.talk(`He left... What are we gonna do now? There is not enough time to keep practicing.`);
    mc.talk(`There is nothing much we can do. Let's go and hope for the best.`);
    ann.talk(`Yeah... I hope luck will be on my side.`);
    mc.talk(`Me too.`);
    mc.talk(`Let's go.`);
    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};

export const V7AnnPreAuditionNtr_InviteChris2_Question_KeepDoing = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    mc.talk(`Keep doing what you're doing.`);
    ann.talk(`Ok.`);
    mc.talk(`Action!`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_10);
    ann.talk(`Please honey! I love you! Stay with me!`);
    chris.talk(`No.`);
    ann.talk(`Please?`);
    chris.talk(`Nope.`);
    ann.talk(`I promise that I'll become a better person!`);
    ann.talk(`I'm at your mercy! My life will be nothing without you.`);
    chris.talk(`Ok I forgive you.`);
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_9, partialsToDisplay: [images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_9_p] });
    ann.talk(`Ah...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_11);
    mc.talk(`That was fucking bad.`);
    ann.talk(`...`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_9.partials.AnnChrisPreAudition_11_3_p);
    ann.talk(`I tried my best...`);
    mc.think(`I hope she has other plans than that.`);
    mc.talk(`Yeah...`);
    chris.talk(`Anyway guys, it was fun but I need to get going now.`);
    chris.talk(`Cya.`);
    ImageClass.setImage(images.v7.AnnChrisPreAudition_41, { transition: true, duration: 0.6 });
    ann.talk(`I don't feel good about that.`);
    mc.talk(`You tried.`);
    mc.talk(`But that's how you learn. You need to start from somewhere.`);
    ann.talk(`I guess.`);
    ann.talk(`Anyway, we're gonna be late, we should get going.`);
    mc.talk(`Let's go.`);
    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};


export const V7AnnPreAudition_Question_Alone = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.AnnChrisPreAudition_1, partialsToDisplay: [images.v7.AnnChrisPreAudition_1.partials.AnnChrisPreAudition_p] });
    mc.talk(`Nah, I'd rather if it's only us two.`);
    await mc.set((properties) => {
        properties.v7PreAuditionProgress.push("Alone");
    });
    ann.talk(`Oh, ok. I understand why you wouldn't want to invite him.`);

    return jump(V7AnnPreAudition3, "V7AnnPreAudition3");
};


export const V7AnnPreAudition3 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    ann.talk(`So what do you think we should do?`);
    mc.talk(`Since it's just the two of us, you'll just do your thing and I'll stop if I have any tips.`);
    ann.talk(`Ok, but don't expect too much.`);
    mc.talk(`Don't worry.`);
    mc.talk(`Just don't forget your role. You need to convince me, your boyfriend, not to leave you.`);
    ann.talk(`Yeah, I remember... Hehe.`);
    mc.talk(`Ok, start.`);
    ann.talk(`Mmm... Ok.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_4);
    ann.talk(`Hey... I really don't want you to leave... Please.`);
    ann.talk(`I... I know I've been a bad girlfriend but I love you so much! Please don't leave.`);
    mc.talk(`Haha...`, { method: "Quiet Laughter" });
    ImageClass.setImage({ ...images.v7.AnnMCPreAudition_3, partialsToDisplay: [images.v7.AnnMCPreAudition_3.partials.AnnMCPreAudition_3_p] });
    ann.talk(`Hey! Why are you laughing?`);
    mc.talk(`I'm sorry... Your expression is really funny.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_3.partials.AnnMCPreAudition_3_p);
    ann.talk(`Oh... Should I change it?`);
    mc.talk(`I didn't say that. Just do what feels comfortable.`);
    ann.talk(`But it made you laugh.`);
    mc.talk(`So? Don't forgot you'd have to deal with people laughing at you as well.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    ann.talk(`Yeah, you are right.`);

    mc.talk(`Ok, let's try again, I'll try not to laugh this time.`);
    ann.talk(`Please.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_4);
    ann.talk(`Please, please, please don't go.`);
    ann.talk(`I'll do anything, just tell me why are you leaving.`);
    mc.talk(`We've been together for too long, I wanna experience other girls.`);
    ann.talk(`No! Don't say it.`, { method: "Sobbing" });
    mc.talk(`I've made up my mind.`);
    ImageClass.setImage({ ...images.v7.AnnMCPreAudition_3, partialsToDisplay: [images.v7.AnnMCPreAudition_3.partials.AnnMCPreAudition_3_2_p] });
    ann.talk(`Ah...`);
    mc.talk(`Why did you stop?`);
    ann.talk(`I don't know what I'm supposed to do... You gave a concrete answer.`);
    mc.talk(`So? Is that what will make you break character?`);
    ann.talk(`Ah... No?`);
    mc.talk(`That's how you convince someone you love to stay with you?`);
    ann.talk(`I don't know... I've never been in this situation.`);
    mc.talk(`That's the problem, you need to pretend this is real, and you are about to lose him for good.`);
    mc.talk(`You can't just stop and everything goes back to normal.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    ann.talk(`I understand.`);
    return jump(V7AnnPreAudition3_Question, "V7AnnPreAudition3_Question");
};

export const V7AnnPreAudition3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    await ann.setQuestion(new Question({ text: `Do you have more tips before I'll try again?`, options: { think: false }, key: `v7PreAuditionToldAnnToBegAlone` })
        .option({ title: `Beg (Get on your knees)`, key: true })
        .option({ title: `Keep doing what you're doing`, key: false }));


    if (Question.globalAnswers.v7PreAuditionToldAnnToBegAlone) {

        return jump(V7AnnPreAudition3_Question_Beg, "V7AnnPreAudition3_Question_Beg");
    } else {

        return jump(V7AnnPreAudition3_Question_KeepDoing, "V7AnnPreAudition3_Question_KeepDoing");
    }
};

export const V7AnnPreAudition3_Question_Beg = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    await mc.set((properties) => {
        properties.v7PreAuditionProgress.push("Begged");
    });

    mc.talk(`Yes, I do.`);
    mc.talk(`Do, like you did before, but try to be more dramatic.`);
    ann.talk(`How?`);
    mc.talk(`Do something that someone who is desperate for something will do. Beg.`);
    ann.talk(`Didn't I just do that??`);
    mc.talk(`I mean physically.`);
    mc.talk(`Get down on your knees and beg.`);
    ann.talk(`Oh...`);
    ann.talk(`Isn't that too much? I would never do that in real life.`);
    mc.talk(`It's for a movie not real life.`);
    ann.talk(`Yeah...`);
    ann.talk(`Fine.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    ann.talk(`Ahm ahm...`);

    ImageClass.setImage(images.v7.AnnMCPreAudition_4);
    ann.talk(`Please! Please don't leave me.`);
    ann.talk(`I'll do anything you want from now on!`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_5);
    ann.talk(`Please! I'm on my knees begging you to stay.`);
    ann.talk(`What more can I do?`);
    return jump(V7AnnPreAudition3_Beg_Question, "V7AnnPreAudition3_Beg_Question");
};

export const V7AnnPreAudition3_Beg_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_5);
    await mc.setQuestion(new Question({ text: `Damn... Seeing her on her knees like that really makes me horny.\nMaybe I can make some dumb excuse to get naked.`, options: { think: false }, key: `v7PreAuditionAnnSuckedMCCock` })
        .option({ title: `Take off your clothes`, key: true })
        .option({ title: `Stay dressed`, key: false }));


    if (Question.globalAnswers.v7PreAuditionAnnSuckedMCCock) {

        return jump(V7AnnPreAudition3_Beg_Question_Naked, "V7AnnPreAudition3_Beg_Question_Naked");
    } else {
        return jump(V7AnnPreAudition3_Beg_Question_Dressed, "V7AnnPreAudition3_Beg_Question_Dressed");

    }
};


export const V7AnnPreAudition3_Beg_Question_Naked = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_6, { transition: true, duration: 0.6 });
    await mc.set((properties) => {
        properties.v7PreAuditionProgress.push("Blowjob");
    });
    ann.talk(`${mc.name}? What are you doing?`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_7);
    mc.talk(`I'm just getting naked so you'd feel more comfortable.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_8);
    ann.talk(`I don't think that it's working...`);
    mc.talk(`Well, if you'd manage to stay calm and perform while I'm naked surely you could perform even better with a dressed actor, don't you agree?`);
    ann.talk(`Mmm... It's stupid and sounds reasonable at the same time.`);
    mc.talk(`Right.`);
    mc.talk(`Just continue from where we left.`);
    ann.talk(`Ok.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_9);
    ann.talk(`Please honey! I love you! Don't leave me! I'm begging you!`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_10);
    ann.talk(`I don't think that's part of the script...`);
    mc.talk(`Do you really want me to forgive you?`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_11);
    ann.talk(`I do.`);
    ImageClass.setImage(images.v7.Anim_AnnMCPreAudition.poster);
    mc.talk(`You know what to do.`);
    ImageClass.setAnimation(images.v7.Anim_AnnMCPreAudition);
    empty.think(`Sluurp. Fwuup.`);
    mc.think(`Fuck, that feels good.`);
    mc.talk(`Mmhhhmmm... I don't know if I'm convinced yet.`);
    ann.talk(`Pmmwess fmmgguuv mmmh.`);
    empty.think(`Shlllup. Mggghh.`);
    // TODO: add shake effect
    ImageClass.setImage(images.v7.AnnMCPreAudition_16, { duration: 0.6, wait: 0.8 });
    ImageClass.setImage(images.v7.AnnMCPreAudition_17, { duration: 0.6, wait: 0.8 });
    ImageClass.setImage(images.v7.AnnMCPreAudition_18, { duration: 0.6 });
    mc.talk(`AHH!`);

    mc.talk(`I forgive you.`);
    ann.talk(`Hehe.`);
    mc.talk(`I think we are done.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_19);
    ann.talk(`Let me just wash up and we can go!`);
    await endReplay(replayScenesList.v7AnnPreAuditionMC);
    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};

export const V7AnnPreAudition3_Beg_Question_Dressed = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_5);
    ann.talk(`Please honey! My life will be ruined without you!`);
    ann.talk(`I need you! I can't let you go!`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    ann.talk(`How was that?`);
    mc.talk(`Wasn't bad at all!`);
    ann.talk(`Yes? Do you think it was convincing enough?`);
    mc.talk(`A bit dramatic, but it might do the job.`);
    ann.talk(`Great!`);
    mc.talk(`Are you ready to go?`);
    ann.talk(`Yes.`);
    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};

export const V7AnnPreAudition3_Question_KeepDoing = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AnnMCPreAudition_3);
    mc.talk(`Just keep doing what you're doing and you'll be fine.`);
    ann.talk(`Ok! Let me start again.`);
    ImageClass.setImage(images.v7.AnnMCPreAudition_4);

    ann.talk(`Please, please, please don't go.`);
    ann.talk(`I'll do anything, just tell me why are you leaving.`);
    mc.talk(`We've been together for too long, I wanna experience other girls.`);
    ann.talk(`Please honey! I love you! Stay with me!`);
    ann.talk(`Please say something.`);
    mc.talk(`I don't know what to say.`);
    ann.talk(`Don't you love me?`);
    mc.talk(`I do, it's for the best if we split.`);
    ann.talk(`I don't know what to say...`);
    ann.talk(`I promise that I'll become a better person!`);
    ann.talk(`I'm at your mercy! My life will be nothing without you.`);

    if (mc.properties.liar >= 6) {
        mc.talk(`That was good.`);
        ImageClass.setImage({ ...images.v7.AnnMCPreAudition_3, partialsToDisplay: [images.v7.AnnMCPreAudition_3.partials.AnnMCPreAudition_3_2_p] });
        ann.talk(`Really?`);
        mc.talk(`Yeah, I think you'll do great.`);
        ann.talk(`I'm happy to hear that from you! I'm counting on your opinion.`);
    } else {
        ImageClass.setImage({ ...images.v7.AnnMCPreAudition_3, partialsToDisplay: [images.v7.AnnMCPreAudition_3.partials.AnnMCPreAudition_3_2_p] });
        mc.talk(`That was decent.`);
        ann.talk(`Only decent?`);
        mc.talk(`I can't lie... It wasn't that good.`);
        ann.talk(`Oh...`);
        ann.talk(`What else can I improve?`);
        mc.talk(`I think you'll improve with time...`);
        ann.talk(`Oh.`);
    }

    ann.talk(`Anyway, we better get going so we won't be late.`);
    mc.talk(`I agree. Let's go.`);


    return jump(V7AnnPreAuditionEnd, "V7AnnPreAuditionEnd");
};


export const V7AnnPreAuditionEnd = async (): Promise<any> => {

    return jump(V7AnnPreAuditionAfter, "V7AnnPreAuditionAfter");
};

